import i18n from '@/i18n';
import { isClientError } from 'cesg-shared';
import type { NotificationMatcher } from './notification-matcher';

export const sharePointProvisioningBusyNotification: NotificationMatcher = (
  error,
) => {
  if (!isClientError(error, 'SHAREPOINT_PROVISIONING_BUSY')) return null;

  const { t } = i18n.global;
  return {
    title: t('errorNotifications.SHAREPOINT_PROVISIONING_BUSY.title'),
    text: t('errorNotifications.SHAREPOINT_PROVISIONING_BUSY.text'),
    type: 'warning',
  };
};
